import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CatalogueGrid = _resolveComponent("CatalogueGrid")!

  return (_openBlock(), _createElementBlock("div", {
    onFocus: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.resetSelectedRows && _ctx.resetSelectedRows(...args))),
    tabindex: "0",
    ref: "area"
  }, [
    _createVNode(_component_CatalogueGrid, {
      summaryConfig: _ctx.summaryConfig,
      controller: 'PlanOrder',
      columns: _ctx.columns,
      filterRowVisible: true,
      groupPanelVisible: true,
      headerFilterVisible: true,
      filterPanelVisible: false,
      showPageSizeSelector: !_ctx.selectMode,
      pageSize: 10,
      pageSizes: _ctx.pageSizes,
      editingConfig: _ctx.editingConfig,
      selectionConfig: _ctx.selectionConfig,
      designConfig: _ctx.designConfig,
      getSelectedData: _ctx.getSelectedData,
      changeSelectedData: _ctx.changeSelectedData,
      parentModel: _ctx.parentModel,
      importConfig: _ctx.importConfig,
      exportConfig: _ctx.exportConfig,
      selectMode: _ctx.selectMode,
      onUpdateParentModelCallback: _ctx.onUpdateParentModelCallback,
      onEditingStart: _ctx.onEditingStart,
      onEditCanceling: _ctx.onEditCanceling,
      onInitNewRow: _ctx.onInitNewRow,
      onSaving: _ctx.saving,
      onRememberScrollSettings: _ctx.rememberScrollSettings,
      ref: "grid"
    }, null, 8, ["summaryConfig", "columns", "showPageSizeSelector", "pageSizes", "editingConfig", "selectionConfig", "designConfig", "getSelectedData", "changeSelectedData", "parentModel", "importConfig", "exportConfig", "selectMode", "onUpdateParentModelCallback", "onEditingStart", "onEditCanceling", "onInitNewRow", "onSaving", "onRememberScrollSettings"])
  ], 544))
}